import axios from 'axios';
import { useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';

import { getIdentifier, isSpam, setAsked } from '../helpers/modalActions';
import {
  ModalThatHidesChatButton,
  StyledHeader,
  ThankYouContent,
  ThankYouEmoji
} from '../theme/styles';
import { QualiSurveyProps, SurveyValues } from '../types';
import { DefaultSurvey } from './Survey';

const QUALI_API = process.env.CARVANA_APP_QUALI_API;

const QualiSurvey = ({
  commentBoxTitle,
  Content = DefaultSurvey,
  identifier,
  identifierType = 'UserId',
  isOpen,
  meta = {},
  name,
  onClose,
  overrideSpam,
  teamName = 'default',
  title
}: QualiSurveyProps) => {
  const [showThankYou, setShowThankYou] = useState(false);
  const { mutate, isLoading } = useMutation((values: SurveyValues) =>
    axios.post(`${QUALI_API}/v1/survey`, {
      ...values,
      identifier: getIdentifier(identifierType, identifier),
      identifierType,
      metadata: meta,
      surveyName: name,
      teamName
    })
  );

  const onSubmit = (values: SurveyValues) => {
    mutate(values);
    setShowThankYou(true);
  };

  useEffect(() => {
    if (showThankYou) {
      setTimeout(() => {
        setShowThankYou(false);
        setAsked(name, overrideSpam);
        onClose();
      }, 2000);
    }
  }, [showThankYou, onClose, name, overrideSpam]);

  if (isSpam(name, overrideSpam)) {
    if (isOpen) { onClose() }

    return null;
  }

  const content = showThankYou ? (
    <ThankYouContent>
      <ThankYouEmoji>🙌</ThankYouEmoji>
      <StyledHeader>Thank you for your feedback!</StyledHeader>
    </ThankYouContent>
  ) : (
    <Content
      onClose={onClose}
      onSubmit={onSubmit}
      title={title}
      isLoading={isLoading}
      commentBoxTitle={commentBoxTitle}
    />
  );

  return (
    <ModalThatHidesChatButton
      closeModal={onClose}
      disableBackdropClick={false}
      headerText="Share Feedback"
      isOpen={isOpen}
      mode={undefined}
      testHook="qualiSurvey"
    >
      {content}
    </ModalThatHidesChatButton>
  );
};

export default QualiSurvey;
